export const autoCompleteProps = {
    autoSelect: true,
    disableClearable: true,
};
